import { bdcRepository } from './Repository'
import { concatenationUrl } from '@/utils/index'

const resource = 'references'
export default {
  getReferences(customerApiToken = null) {
    const endpoint = `${resource}`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getReference(referenceId, customerApiToken = null) {
    const endpoint = `${resource}/${referenceId}`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getReferenceColors(referenceId, customerApiToken = null) {
    const endpoint = `${resource}/${referenceId}/colors`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getReferenceColorPrices(referenceId, colorId, customerApiToken = null) {
    const endpoint = `${resource}/${referenceId}/colors/${colorId}/prices`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getReferencesCollections(type, customerApiToken = null) {
    const endpoint = `${resource}/collections`
    const qsParams = {
      type: type,
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getReferencesCategories(customerApiToken = null) {
    const endpoint = `${resource}/categories`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
  getNewReferences(customerApiToken = null) {
    const endpoint = `${resource}/new`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  }
}